import { TextField } from "@mui/material";
import { useField } from "formik";

const FormikTextField = (props) => {
  const [field, meta] = useField(props);
  const handleChange = (e) => {
    field.onChange(e);
    props.onChange?.(e);
  };
  const handleBlur = (e) => {
    field.onBlur(e);
    if (props.onBlur) {
      props.onBlur(e);
    }
  };
  return (
    <TextField
      variant={props.filled ? "filled" : "standard"}
      error={meta.touched && meta.error ? true : false}
      helperText={
        meta.touched && meta.error
          ? meta.error
          : props.helperText
            ? props.helperText
            : null
      }
      {...props}
      {...field}
      onBlur={handleBlur}
      multiline={props.multiline ?? false}
      onChange={handleChange}
    />
  );
};

export default FormikTextField;
